export default __webpack_public_path__ + "static/media/img4.1b902b5f.svg";